import { client } from 'util/sdk';
import { GET } from 'util/api';

const mapPalConfigField = (profile) => {
  if (!profile?.fsppalconfig) return profile;
  const { inFrontOfPinSubdomain, guestUrl, ...rest } = profile.fsppalconfig;
  return {
    ...profile,
    fsppalconfig: {
      ...rest,
      guestUrl:
        inFrontOfPinSubdomain !== undefined ? inFrontOfPinSubdomain : guestUrl,
    },
  };
};

// eslint-disable-next-line import/prefer-default-export
export const loadFSPProfile = ({ fspId }) =>
  client
    .executeRequest(GET, `/fsps/${fspId}/profile`, {
      returnModel: {
        name: 'fspprofile',
      },
    })
    .then(mapPalConfigField);
